var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var listeners = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":_vm.statusColor}},listeners),[_vm._v(_vm._s(_vm.statusIcon))])]}}])},'v-tooltip',_vm.$attrs,false),[_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }